//Submenus fuera de la pantalla

window.addEventListener("load", function() {

    const itemMenu = $('.tmenu_item_level_0');
    $(itemMenu).on('mouseenter', function() {
        const screenWidth = $(window).width();
        const maxWidthMenu = screenWidth / 2;

        $(this).find('.tmenu_submenu--desktop').each(function(index) {
            if ($(this).offset().left > maxWidthMenu + 200) {
                $(this).css('left', '-100%');
            }
        });
    });
})

//--- Modificaciones menú para dejarlo en una linea y poner flecha a la izquiera
setTimeout(function() {
    var menu = document.querySelectorAll(".tmenu_nav .tmenu_item_level_0");
    menu.forEach(function(element, index) {
        if (index !== 0) {
            var icon = element.querySelector('.tmenu_indicator');
            var text = element.querySelector('.tmenu_item_text');
            var editText = text.textContent;
            var link = element.querySelector('.tmenu_item_link');

            text.remove();
            icon.remove();
            link.appendChild(icon);
            text.textContent = text.textContent.replace("|", "");
            link.appendChild(text);

        }
    });

}, 500);



function comprueba() {
    if (check.checked) {
        document.getElementById("subscribe").disabled = false;
        document.getElementById("mail").focus();
        //document.getElementById("mail").disabled = false;
    } else {
        document.getElementById("subscribe").disabled = true;
        //document.getElementById("mail").disabled = true;
    }
}

$(document).ready(function () {
    var check = document.getElementById('check');
    var subbs = document.getElementById("subscribe"); //Se crea variable para verificar si existe el bloque de suscripción en el footer
    if (!subbs) { //si no hacemos esto, al quitar el bloque u ocultarlo, se rompe el slider y el footer entero
        return;
    } else {
        subbs.disabled = true;
    }
    //document.getElementById("subscribe").disabled = true;
    //document.getElementById("mail").disabled = true;
    if (!check) {
        return;
    } else {
        check.addEventListener("change", comprueba, false);
    }
});



//filtros categorias
setTimeout(function() {
    if (document.querySelector("#shopify-section-collection")) {
        var cargado = false;

        $('#toggleFilters--desktop').click(function(e) {

            if (cargado === false) {

                cargado = true;

                setTimeout(function() {

                    var bbStyle = document.createElement('style');

                    bbStyle.setAttribute('type', 'text/css');

                    bbStyle.innerHTML = ".bb-closed {margin-bottom:0;overflow: hidden;}.trigger {margin-bottom:10px; margin-left: 25px; border: none;width: 100px; background-color: #e8e8e8; color: #000}.trigger:hover {background-color: #9c9c9c; color:#fff}.trigger-content {content: -}";

                    document.head.appendChild(bbStyle);

                    var categorias = $('.collection-nav');

                    var totalItemsToShow = 5;

                    function getHeight(el) {
                        var totalHeight = 0;
                        var elMarginBottom = el.css('margin-bottom');



                        el.each(function(i) {
                            if (i < totalItemsToShow) {
                                totalHeight = totalHeight + $(this).height() + parseFloat(elMarginBottom);
                            }
                        })
                        return totalHeight;
                    }

                    categorias.each(function(index) {
                        var $this = $(this);
                        var children = $this.children('li');

                        children.each(function(index) {
                            if ($(this).hasClass('link--disable')) {
                                $(this).remove();
                            }
                        })

                        if ($this.children().length > totalItemsToShow) {
                            var $parentEl = $this.parent();
                            var itemsHeight = getHeight($this.children('.sidebar__item'));

                            $this.addClass("bb-closed");

                            $parentEl.append("<button class='trigger'>+</button>");

                            $this.css('height', itemsHeight + 'px');
                        }
                    })

                    $('#toggleFilters').click(function(e) {

                        var filter = $('.collectionFilters');


                        if (filter.css('display') == 'none') {
                            setTimeout(function() {
                                categorias.each(function(index) {
                                    var $this = $(this);

                                    if ($this.children().length > totalItemsToShow) {
                                        var $parentEl = $this.parent();
                                        var itemsHeight = getHeight($this.children('.sidebar__item'));

                                        $this.addClass("bb-closed");

                                        $this.css('height', itemsHeight + 'px');
                                    }
                                })
                            }, 100);
                        } else {
                            $('.trigger').each(function() {
                                $(this).text('+');
                            })
                        }

                    })


                    $('.trigger').click(function(e) {
                        var iParent = $(this).parent().find('.collection-nav');
                        var iChield = iParent.children('.sidebar__item');
                        var iButton = $(this).parent().find('.trigger');
                        var iHeight = getHeight(iChield);


                        if (iParent.height() == iHeight) {
                            iParent.css('height', 'auto');
                            iButton.text('-');
                        } else {
                            iParent.css('height', iHeight + 'px');
                            iButton.text('+');
                        }
                    })

                    //ordenación Jquery

                    numerically_ignore_letters = function(a, b) {
                        var non_digits = '^(\d)*';
                        var a_val = parseInt($('a', a).text().replace(non_digits, ''), 10);
                        var b_val = parseInt($('a', b).text().replace(non_digits, ''), 10);

                        return a_val - b_val;
                    }

                    elementos = $('ul.collection-nav');
                    elementos.each(function() {
                        // Ordenar numéricamente los filtros
                        $(this).children('li').sort(numerically_ignore_letters).prependTo($(this));
                    });


                }, 1000);
            };
        });

        $('#toggleFilters').click(function(e) {


            if (cargado === false) {

                cargado = true;
                setTimeout(function() {

                    var bbStyle = document.createElement('style');

                    bbStyle.setAttribute('type', 'text/css');

                    bbStyle.innerHTML = ".bb-closed {margin-bottom:0;overflow: hidden;}.trigger {margin-bottom:10px; margin-left: 25px; border: none;width: 100px; background-color: #e8e8e8; color: #000}.trigger:hover {background-color: #9c9c9c; color:#fff}.trigger-content {content: -}";

                    document.head.appendChild(bbStyle);

                    var categorias = $('.collection-nav');

                    var totalItemsToShow = 5;

                    function getHeight(el) {
                        var totalHeight = 0;
                        var elMarginBottom = el.css('margin-bottom');

                        el.each(function(i) {
                            if (i < totalItemsToShow) {
                                totalHeight = totalHeight + $(this).height() + parseFloat(elMarginBottom);
                            }
                        })
                        return totalHeight;
                    }

                    categorias.each(function(index) {
                        var $this = $(this);
                        var children = $this.children('li');

                        children.each(function(index) {
                            if ($(this).hasClass('link--disable')) {
                                $(this).remove();
                            }
                        })

                        if ($this.children().length > totalItemsToShow) {
                            var $parentEl = $this.parent();
                            var itemsHeight = getHeight($this.children('.sidebar__item'));

                            $this.addClass("bb-closed");

                            $parentEl.append("<button class='trigger'>+</button>");

                            $this.css('height', itemsHeight + 'px');
                        }
                    })

                    $('#toggleFilters').click(function(e) {

                        var filter = $('.collectionFilters');


                        if (filter.css('display') == 'none') {
                            setTimeout(function() {
                                categorias.each(function(index) {
                                    var $this = $(this);

                                    if ($this.children().length > totalItemsToShow) {
                                        var $parentEl = $this.parent();
                                        var itemsHeight = getHeight($this.children('.sidebar__item'));

                                        $this.addClass("bb-closed");

                                        $this.css('height', itemsHeight + 'px');
                                    }
                                })
                            }, 100);
                        } else {
                            $('.trigger').each(function() {
                                $(this).text('+');
                            })
                        }

                    })


                    $('.trigger').click(function(e) {
                        var iParent = $(this).parent().find('.collection-nav');
                        var iChield = iParent.children('.sidebar__item');
                        var iButton = $(this).parent().find('.trigger');
                        var iHeight = getHeight(iChield);


                        if (iParent.height() == iHeight) {
                            iParent.css('height', 'auto');
                            iButton.text('-');
                        } else {
                            iParent.css('height', iHeight + 'px');
                            iButton.text('+');
                        }
                    });

                    //ordenación Jquery

                    numerically_ignore_letters = function(a, b) {
                        var non_digits = '^(\d)*';
                        var a_val = parseInt($('a', a).text().replace(non_digits, ''), 10);
                        var b_val = parseInt($('a', b).text().replace(non_digits, ''), 10);

                        return a_val - b_val;
                    }

                    elementos = $('ul.collection-nav');
                    elementos.each(function() {
                        // Ordenar numéricamente los filtros
                        $(this).children('li').sort(numerically_ignore_letters).prependTo($(this));
                    });


                }, 500);

            };


        });
    }

}, 1000);